module.exports = __webpack_public_path__ + "static/img/grxx.2eecb902.png";